const usernameHoldersList: { [key: string]: string } = {
  username: 'Please input your username: ',
  usernameRetry: 'Input your username again: ',
};

export default usernameHoldersList;
